import {
  GET_USER_REQUEST,
  GET_USER_SUCCESS,
  GET_USER_FAILURE,
} from './constants';
import { getCurrentUser as fetchCurrentUser } from '../core/user';

export const getCurrentUser = (courseId) => async (dispatch) => {
  dispatch({ type: GET_USER_REQUEST });
  try {
    const userData = await fetchCurrentUser(courseId);
    dispatch({
      type: GET_USER_SUCCESS,
      payload: userData,
    });
  } catch (error) {
    dispatch({
      type: GET_USER_FAILURE,
      error: true,
      payload: error,
    });
  }
};
